// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"379":"a28ffe54e77abb30686f","544":"26d7f4a96435ceed3914","572":"09006a6300f03ab21225","656":"5d96e4e4bc09c24d0cee","778":"4891d0bd10501f85c671","900":"811c8870afe5792b96de"}[chunkId] + ".chunk.js";
};